exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-login-page[data-v-2a782a6d]{padding:0}.settings-login-page__card[data-v-2a782a6d]{max-width:640px}.settings-login-page__form[data-v-2a782a6d]{max-width:100%}.settings-login-page__input[data-v-2a782a6d]{max-width:520px}.settings-login-page__input-short[data-v-2a782a6d]{max-width:280px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a782a6d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/SettingsLoginPage.vue
// module id = vazo
// module chunks = 0